import { Link } from 'react-router-dom'
import {button} from '../models'

export function Button(props: button){
  return(
    <div className="button-wrapper">
      <Link to={props.buttonUrl} className={props.buttonClass}>{props.buttonText}</Link>
    </div>  
  )
}